import { create } from 'zustand'
import { persist, devtools } from 'zustand/middleware'

function isDateMoreThanOneHourAhead(date) {
    const dateObj = new Date(date);

    const oneHourInMilliseconds = 60 * 60 * 1000; // number of milliseconds in one hour
    const now = new Date(); // current date and time
    const difference =  now.getTime() - dateObj.getTime(); // difference in milliseconds between the given date and the current date

    //console.log("Difs: ", dateObj, now, difference, oneHourInMilliseconds, difference > oneHourInMilliseconds)

    return difference > oneHourInMilliseconds; // return true if the difference is greater than one hour, false otherwise
}

const WEATHER_END_POINT = '/.netlify/functions/get-weather'

const getWeather = async ({lat, lon}) => {
    const response = await fetch(`${WEATHER_END_POINT}?latitude=${lat}&longitude=${lon}`)
    .then((response) => response.json())
    .then((data) => data.weather);

    return response
}


const setWeatherStore = (set, get) => ({
    location : { lat : '-32.93', lon : '151.78' },
    lastCheck : '',
    timezone: 'Australia/Sydney',
    timezoneAbbreviation: 'AEDT',
    weatherData : {},
    currentWeather: {},
    dailyForecast: {},
    display: 'full',
    columns: 'auto',

    setColumns: ( columns ) => set( () => ({ columns: columns }) ),
    setDisplay: ( display ) => set( () => ({ display: display }) ),

    checkWeather : () => {
        const lastCheck = get().lastCheck;
        console.log("Seeing if weather needs to be checked ", lastCheck)

        if(lastCheck) {
            //const lastCheckDate = new Date(lastCheck)
            const weatherNeedsRefreshing = isDateMoreThanOneHourAhead(lastCheck)


            if(!weatherNeedsRefreshing) console.log('Weather is ok');

            if(!weatherNeedsRefreshing) return; // i.e. a refresh is not required
        }

        console.log("Weather refresh required: ")
        const handleWeatherAPI = get().handleWeatherAPI;
        handleWeatherAPI()
    },

    handleWeatherAPI : async () => {
        console.log('Checking the weather')
        const location = get().location;
        const weatherData = await getWeather(location)

        set({
            lastCheck : await weatherData.currentWeather.time,
            currentWeather : await weatherData.currentWeather,
            dailyForecast: await weatherData.daily,
            weatherData : { daily: await weatherData.daily, dailyUnits: await weatherData.dailyUnits }
        })
    },
    setLocation: ( location ) => set( () => ({ location :  location })  ),
    setTimezone: ( timezone ) => set( () => ({ timezone :  timezone })  ),
    setTimezoneAbbreviation: ( timezoneAbbreviation ) => set( () => ({ timezoneAbbreviation :  timezoneAbbreviation })  ),
})

const persistWeatherStore = persist(devtools(setWeatherStore), { name: 'jd_weather_store' })

const useWeatherStore = create( persistWeatherStore )

export { useWeatherStore }


/**
 * https://open-meteo.com/en/docs
 * https://open-meteo.com/en/docs#latitude=-32.93&longitude=151.78&hourly=temperature_2m,relativehumidity_2m,apparent_temperature,precipitation_probability,weathercode&daily=weathercode,temperature_2m_max,temperature_2m_min,precipitation_hours,precipitation_probability_max&current_weather=true&timezone=Australia%2FSydney
 *  https://api.open-meteo.com/v1/forecast?latitude=-32.93&longitude=151.78&hourly=temperature_2m,relativehumidity_2m,apparent_temperature,precipitation_probability,weathercode&daily=weathercode,temperature_2m_max,temperature_2m_min,precipitation_hours,precipitation_probability_max&current_weather=true&timezone=Australia%2FSydney
 * 
 * 
 * WMO Weather interpretation codes (WW)
    Code	    Description
    0	        Clear sky // sun
    1, 2, 3	    Mainly clear, partly cloudy, and overcast // cloud-sun
    45, 48	    Fog and depositing rime fog // smog
    51, 53, 55	Drizzle: Light, moderate, and dense intensity // cloud-rain
    56, 57	    Freezing Drizzle: Light and dense intensity - icicles
    61, 63, 65	Rain: Slight, moderate and heavy intensity - cloud-showers-heavy
    66, 67	    Freezing Rain: Light and heavy intensity - snowflake
    71, 73, 75	Snow fall: Slight, moderate, and heavy intensity - snowflake
    77	        Snow grains - snowflake
    80, 81, 82	Rain showers: Slight, moderate, and violent - cloud-rain
    85, 86	    Snow showers slight and heavy - cloud-showers-heavy
    95 *	    Thunderstorm: Slight or moderate - cloud-bolt
    96, 99 *	Thunderstorm with slight and heavy hail - cloud-meatball
 */